<style>
.jbsmall_button {
	border-width: 1px;
	border-style: solid;
	border-radius: 4px;
	padding-left: 10px;
	padding-right: 10px;
	margin: 1px;
}
</style>

<template>
	<div class="jbsmall_button" :style="style" @click.prevent="do_click()">
		<slot>click me</slot>
	</div>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: 'black'
		}
	},
	computed: {
		style: function() {
			let style = '';

			style += 'color: ' + this.color + ';';

			return style;
		}
	},
	methods: {
		do_click: function() {
			this.$emit('click')
		}
	}
}
</script>
